import { FETCH_PSATYPICAL } from "../../actions/types";

const INITIAL_STATE = {
  events: []
};

const atypicalReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PSATYPICAL:
      return payload.data;
    default:
      return state;
  }
};

export default atypicalReducer;



// WEBPACK FOOTER //
// ./src/reducers/helpers/atypical_reducer.js